import React, { useEffect, useRef, useState } from "react";
import "./registerForm.css";
import * as Yup from "yup";
import { Field, Form, Formik, useField, useFormikContext } from "formik";
import CreatableSelect from "react-select/creatable";
import logoutimg from "../../assets/logout.png";
import ErrorMsg from "../../components/form/errorMsg";
import { useDispatch } from "react-redux";
import { contactDetail } from "../../redux/actions/onBordingActions";
import { useNavigate } from "react-router-dom";
import { logout } from "../../redux/actions/authActions";
import Select from "react-select";
import {
  fetchCityList,
  fetchDistrictList,
  fetchPincodeAutoList,
  fetchStateList,
} from "../../redux/actions/commonActions";
import ErrorPopup from "../../components/Popups/ErrorPopup";
import SuccessPopup from "../../components/Popups/SuccessPopUp";
import "../../components/utilites/optionalYup";
const RegisterContactDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [disable, setDisable] = useState(true);
  const [stateOptions, setStateOptions] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [showErrorPopup1, setShowErrorPopup1] = useState(false);
  const [showErrorMsg1, setShowErrorMsg1] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState("");
  const [showSuccessPopup1, setShowSuccessPopup1] = useState(false);
  const [showSuccessMsg1, setShowSuccessMsg1] = useState("");
  const [pincodeSet, setPincodeSet] = useState(null);
  const [intValues, setintValues] = useState();

  const emailValue = localStorage.getItem("email");

  useEffect(() => {
    dispatch(fetchStateList(onGetStateSuccess, onGetStateError));
  }, []);

  useEffect(() => {
    if (pincodeSet != null) {
      dispatch(
        fetchPincodeAutoList(
          { pincode: pincodeSet },
          onGetPincodeSuccess,
          onGetPincodeError
        )
      );
    }
  }, [pincodeSet]);

  const onGetPincodeSuccess = (data) => {
    console.log(data?.data?.data?.state_id, "pin");
    // setPincodeData(data?.data?.data);
    setSelectedState(data?.data?.data?.state_id);
    setSelectedDistrict(data?.data?.data?.district_id);
    setSelectedCity(data?.data?.data?.city_id);
  };

  console.log(selectedState, "pin");
  const onGetPincodeError = (err) => {
    console.log(err);
  };

  useEffect(() => {
    if (selectedState !== null) {
      dispatch(
        fetchDistrictList(
          { state_id: selectedState },
          onGetDistrictSuccess,
          onGetDistrictError
        )
      );
    }
  }, [selectedState]);

  useEffect(() => {
    if (selectedState !== null && selectedDistrict !== null) {
      dispatch(
        fetchCityList(
          { state_id: selectedState, district_id: selectedDistrict },
          onGetCitySuccess,
          onGetCityError
        )
      );
    }
  }, [selectedDistrict]);

  const onGetStateSuccess = (data) => {
    console.log(data);
    setStateOptions(data);
  };
  const onGetStateError = (err) => {
    console.log(err);
  };

  const handlePincode = (e, setFieldValue) => {
    console.log(e.target.value.length, "pin");
    setFieldValue("pincode", e.target.value);
    if (e.target.value.length === 6) {
      setPincodeSet(e.target.value);
    } else {
      setSelectedState(null);
      setSelectedDistrict(null);
      setSelectedCity(null);
    }
  };

  const phoneregex = /^([+]\d{2})?\d{10}$/;
  const pincoderegex = /^[1-9]{1}[0-9]{2}\s{0,1}[0-9]{3}$/;
  const initialValues = {
    mobile: intValues?.mobile ? intValues?.mobile : "",
    alternate_mobile: intValues?.alternate_mobile
      ? intValues?.alternate_mobile
      : "",
    email: emailValue,
    alternate_email: intValues?.alternate_email
      ? intValues?.alternate_email
      : "",
    address_one: intValues?.address_one ? intValues?.address_one : "",
    address_two: intValues?.address_two ? intValues?.address_two : "",
    address_three: intValues?.address_three ? intValues?.address_three : "",
    landmark: intValues?.landmark ? intValues?.landmark : "",
    pincode: pincodeSet == null ? "" : pincodeSet,
    state_id: selectedState ? selectedState : "",
    district_id: selectedDistrict ? selectedDistrict : "",
    city_id: selectedCity ? selectedCity : "",
    districts: intValues?.districts?intValues.districts:[],
  };

  const loginSchema = Yup.object().shape({
    mobile: Yup.string()
      .matches(phoneregex, "Invalid Phone Number")
      .required("Required"),
    alternate_mobile: Yup.string().matches(phoneregex, "Invalid Phone Number").optional(),
    email: Yup.string().email("Not a proper email").trim().required("Required"),
    alternate_email: Yup.string().email("Not a proper email").trim().optional(),
    address_one: Yup.string().required("Required"),
    address_two: Yup.string().optional(),
    address_three: Yup.string().optional(),
    landmark: Yup.string().optional(),
    state_id: Yup.string().required("Required"),
    district_id: Yup.string().required("Required"),
    city_id: Yup.string().required("Required"),
    pincode: Yup.string()
      .matches(pincoderegex, "Invalid Pincode")
      .required("Required"),
    districts: Yup.array()
      .min(1, "At least one should be selected")
      .required("Required"),
  });

  const onSubmit = (values, { resetForm }) => {
    console.log(values);
    values["address"] = {
      address_one: values.address_one,
      address_two: values.address_two,
      address_three: values.address_three,
      landmark: values.landmark,
    };
    dispatch(contactDetail(values, onSuccess, onError));
  };

  const timeOutFnc = () => {
    setShowSuccessPopup(false);
    navigate("/current-orders");
  };
  const onSuccess = (data) => {
    console.log(data);
    setShowSuccessPopup(true);
    const message = data.data.message;
    const msg_updated = message.charAt(0).toUpperCase() + message.slice(1);
    setShowSuccessMsg(msg_updated);
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    console.log("zxcsdcsd", str);
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  const FormEnableCheck = () => {
    const {
      values: {
        mobile,
        // alternate_mobile,
        // email,
        // alternate_email,
        address_one,
        address_two,
        address_three,
        landmark,
        state_id,
        district_id,
        city_id,
        pincode,
        districts,
      },
    } = useFormikContext();
    useEffect(() => {
      console.log("useEffect useFormikContext call",      address_one,
        address_two,
        address_three,
        landmark,
        state_id,
        district_id,districts);
      if (
        address_one.trim() !== "" &&
        state_id.trim() !== "" &&
        district_id.trim() !== "" &&
        city_id.trim() !== "" &&
        pincode.trim() !== "" &&
        districts.length > 0
      ) {
        setDisable(false);
      } else {
        setDisable(true);
      }
    }, [
      mobile,
      // alternate_mobile,
      // email,
      // alternate_email,
      address_one,
      address_two,
      address_three,
      landmark,
      state_id,
      district_id,
      city_id,
      pincode,
      districts,
    ]);
    return null;
  };

  const onGetDistrictSuccess = (data) => {
    setDistrictOptions(data);
    console.log(data);
  };
  const onGetDistrictError = (err) => {
    console.log(err);
  };

  const onGetCitySuccess = (data) => {
    setCityOptions(data);
    console.log(data);
  };
  const onGetCityError = (err) => {
    console.log(err);
  };

  const logoutHandler = () => {
    dispatch(logout(logoutSuccess, logoutError));
  };

  const timeOutFnc1 = () => {
    setShowSuccessPopup1(false);
    navigate("/login");
  };
  const logoutSuccess = (data) => {
    console.log(data);
    setShowSuccessPopup1(true);
    const message1 = data.data.message;
    const msg_updated1 = message1.charAt(0).toUpperCase() + message1.slice(1);
    setShowSuccessMsg1(msg_updated1);
    setTimeout(timeOutFnc1, 2000);
  };

  const closeErrorPopup1 = () => {
    setShowErrorPopup1(false);
  };

  const logoutError = (err) => {
    console.log(err);
    setShowErrorPopup1(true);
    const str1 = err.data.message;
    const str_modify1 = str1.charAt(0).toUpperCase() + str1.slice(1);
    setShowErrorMsg1(str_modify1);
  };

  return (
    <div className="register-main-container  d-flex justify-content-center align-items-center">
      <div className="register-form-container col-10 col-md-6 px-2  mx-auto my-2 py-3  ">
        <div className="d-flex justify-content-between px-3 mx-2 mt-3">
          <div>
            <label className="fw_500 fn_Nunito fs_20 fs_md_18 fs_sm_16">
              Distribution Details
            </label>
          </div>
          <div
            className="d-flex align-items-center mb-md-3 cursor_pointer"
            onClick={() => logoutHandler()}
          >
            <span className="fs_12 fs_sm_10  fw_600 color_2ad3e7">Logout</span>
            <img className="mx-1" src={logoutimg} height="12px" />
          </div>
        </div>
        <div className="mt-4">
          <Formik
            initialValues={initialValues}
            validationSchema={loginSchema}
            onSubmit={onSubmit}
            enableReinitialize={true}
          >
            {({ errors, setFieldValue, values }) => {
              setintValues(values);
              return (
                <Form>
                  <FormEnableCheck />
                  <div className="">
                    <div className="regform-container mx-2 px-3 my-2">
                      <div className="w-100 ">
                        <label className="w-100 mx-1 fn_Nunito fs_14 fs_sm_12">
                          Mobile Number
                        </label>
                        <Field name={"mobile"}>
                          {({ field, meta }) => (
                            <input
                              {...field}
                              type="text"
                              maxlength={10}
                              placeholder="Enter your mobile number"
                              id={"mobile"}
                              className={"w-100 input-field"}
                            />
                          )}
                        </Field>
                        <ErrorMsg name="mobile" />
                      </div>
                      <div className="w-100 mt-">
                        <label className="w-100 mx-1 fn_Nunito fs_14  ">
                          Alternative Mobile Number
                        </label>
                        <Field name={"alternate_mobile"}>
                          {({ field, meta }) => (
                            <input
                              {...field}
                              type="text"
                              maxLength={10}
                              placeholder="Enter your alternative mobile number"
                              id={"alternate_mobile"}
                              className={"w-100 input-field"}
                            />
                          )}
                        </Field>
                        <ErrorMsg name="alternate_mobile" />
                      </div>
                      <div className="w-100 ">
                        <label className="w-100 mx-1 fn_Nunito fs_14 fs_sm_12">
                          Email Address
                        </label>
                        <Field name={"email"}>
                          {({ field, meta }) => (
                            <input
                              disabled
                              {...field}
                              type="text"
                              // maxlength={10}
                              placeholder="Enter your email address"
                              id={"email"}
                              className={"w-100 input-field"}
                            />
                          )}
                        </Field>
                        <ErrorMsg name="email" />
                      </div>
                      <div className="w-100 ">
                        <label className="w-100 mx-1 fn_Nunito fs_14 fs_sm_12">
                          Alternative Email Address
                        </label>
                        <Field name={"alternate_email"}>
                          {({ field, meta }) => (
                            <input
                              {...field}
                              type="text"
                              // maxlength={10}
                              placeholder="Enter your alternative email address"
                              id={"alternate_email"}
                              className={"w-100 input-field"}
                            />
                          )}
                        </Field>
                        <ErrorMsg name="alternate_email" />
                      </div>
                      <div className="w-100 mt-">
                        <label className="w-100 mx-1 fn_Nunito fs_14  ">
                          Address
                        </label>
                        <Field name={"address_one"}>
                          {({ field, meta }) => (
                            <input
                              {...field}
                              placeholder="Address line 1"
                              id={"address_one"}
                              className={"w-100 input-field my-1"}
                            />
                          )}
                        </Field>
                        <Field name={"address_two"}>
                          {({ field, meta }) => (
                            <input
                              {...field}
                              placeholder="Address line 2"
                              id={"address_two"}
                              className={"w-100 input-field my-1"}
                            />
                          )}
                        </Field>
                        <Field name={"address_three"}>
                          {({ field, meta }) => (
                            <input
                              {...field}
                              placeholder="Address line 3"
                              id={"address"}
                              className={"w-100 input-field my-1"}
                            />
                          )}
                        </Field>
                        {(errors.address_one && (
                          <ErrorMsg name={"address_one"} />
                        )) ||
                          (errors.address_two && (
                            <ErrorMsg name={"address_two"} />
                          )) ||
                          (errors.address_three && (
                            <ErrorMsg name={"address_three"} />
                          ))}
                      </div>
                      <div className="w-100 mt-3">
                        <label className="w-100 mx-1 fn_Nunito fs_14">
                          Landmark
                        </label>
                        <Field name={"landmark"}>
                          {({ field, meta }) => (
                            <input
                              {...field}
                              placeholder="Enter you landmark"
                              id={"landmark"}
                              className={"w-100 input-field"}
                            />
                          )}
                        </Field>
                        <ErrorMsg name="landmark" />
                      </div>
                      <div className="w-100 mt-">
                        <label className="w-100 mx-1 fs_14"> Pincode </label>
                        <Field name={"pincode"}>
                          {({ field, meta }) => (
                            <input
                              {...field}
                              placeholder="Enter your pincode"
                              id={"pincode"}
                              className={"w-100 input-field"}
                              onChange={(e) => handlePincode(e, setFieldValue)}
                            />
                          )}
                        </Field>
                        <ErrorMsg name="pincode" />
                      </div>
                      <div className="select-container">
                        <label className="w-100 mx-1 fn_Nunito fs_14">
                          State
                        </label>
                        <Field name={"state_id"}>
                          {({ field, meta }) => (
                            <Select
                              {...field}
                              options={stateOptions}
                              styles={customStyles}
                              placeholder={"Enter your state"}
                              value={stateOptions.filter(
                                (s) => s.value == values.state_id
                              )}
                              onChange={(selected) => {
                                setSelectedState(selected?.value);
                                setFieldValue("state_id", selected?.value);
                              }}
                            />
                          )}
                        </Field>
                        <ErrorMsg name="state_id" />
                      </div>
                      <div className="select-container">
                        <label className="w-100 mx-1 fn_Nunito fs_14">
                          District
                        </label>
                        <Field name={"district_id"}>
                          {({ field, meta }) => (
                            <Select
                              {...field}
                              options={districtOptions}
                              styles={customStyles}
                              placeholder={"Enter your district"}
                              value={districtOptions.filter(
                                (s) => s.value == values.district_id
                              )}
                              onChange={(selected) => {
                                setSelectedDistrict(selected?.value);
                                setFieldValue("district_id", selected?.value);
                              }}
                            />
                          )}
                        </Field>
                        <ErrorMsg name="district_id" />
                      </div>
                      <div className="select-container">
                        <label className="w-100 mx-1 fw_400 fn_Nunito fs_14">
                          City
                        </label>
                        <Field name={"city_id"}>
                          {({ field, meta }) => (
                            <Select
                              {...field}
                              options={cityOptions}
                              styles={customStyles}
                              placeholder={"Enter your city"}
                              value={cityOptions.filter(
                                (s) => s.value == values.city_id
                              )}
                              onChange={(selected) => {
                                setSelectedCity(selected?.value);
                                setFieldValue("city_id", selected?.value);
                              }}
                            />
                          )}
                        </Field>
                        <ErrorMsg name="city_id" />
                      </div>

                      <div className="w-100 mb-5">
                        <label className="w-100 mx-1 fn_Nunito fs_14">
                          District Covered for Distribution
                        </label>
                        <Field name={"districts"}>
                          {({ field, meta }) => (
                            <Select
                              {...field}
                              isMulti
                              options={districtOptions}
                              styles={customStyles}
                              placeholder={"Enter district to be covered"}
                              value={districtOptions.find(
                                (s) => s.value == values.districts
                              )}
                              onChange={(selected) => {
                                setFieldValue(
                                  "districts",
                                  selected
                                    ? selected.map((item) => item.value)
                                    : []
                                );
                              }}
                            />
                          )}
                        </Field>
                        <ErrorMsg name="districts" />
                      </div>
                    </div>
                    <div className="px-3 mx-2">
                        <button
                          type="submit"
                          className="register-button fs_16"
                          disabled={disable}
                        >
                          Submit
                        </button>
                      </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
          <ErrorPopup
            show={showErrorPopup}
            title={showErrorMsg}
            handleClose={closeErrorPopup}
          />
          <ErrorPopup
            show={showErrorPopup1}
            title={showErrorMsg1}
            handleClose={closeErrorPopup1}
          />
          <SuccessPopup show={showSuccessPopup} title={showSuccessMsg} />
          <SuccessPopup show={showSuccessPopup1} title={showSuccessMsg1} />
        </div>
      </div>
    </div>
  );
};

export default RegisterContactDetails;

export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    // minHeight: '40px',
    // height: "35px",

    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  dropdownIndicator: (base) => ({
    ...base,
    display: "none", // Custom colour
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  option: (provided, state) => ({
    ...provided,
    // textAlign : "center" ,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",
    // fontFamily: "Nunito",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};
